import { ElementRef, Injectable } from '@angular/core';
import { BaseMessage, WebSocketService } from '../service/websocket.service';

@Injectable({
  providedIn: 'root',
})
export class ScreenShareService {
  private peerConnection: RTCPeerConnection | null = null;
  private remoteVideoRef: ElementRef<HTMLVideoElement> | null = null;
  private localUserSub: string = '';
  private remoteUserSub: string = '';
  private skipIceCandidate: boolean = false;
  
  constructor(private webSocketService: WebSocketService) { }

  initialize(
    userSub: string,
    remoteSub: string,
    videoRef: ElementRef<HTMLVideoElement>
  ) {
    this.localUserSub = userSub;
    this.remoteUserSub = remoteSub;
    this.remoteVideoRef = videoRef;
  }

  // Set up connection
  private setupPeerConnection() {
    //Set up the STUN/TURN server
   const iceServers: RTCIceServer[] = [
  {
    urls: "stun:52.60.166.147:3478"
  },
  {
    urls: "turns:ifm-dev.mwstudio.io:5349", // "turns" = TURN over TLS
    username: "myuser",
    credential: "password123"
  }
];
    this.peerConnection = new RTCPeerConnection({ iceServers: iceServers });

    this.peerConnection.onicecandidate = (event) => {
      if (event.candidate && !this.skipIceCandidate) {
        this.webSocketService.send({
          ACTION: 'SCREEN_SHARE_CANDIDATE',
          CONTENT: {
            candidate: event.candidate,
            target: this.remoteUserSub,
            sender: this.localUserSub,
          },
        });
        this.skipIceCandidate = true
      }
    };

    this.peerConnection.ontrack = (event) => {
      if (this.remoteVideoRef && event.streams.length > 0) {
        this.remoteVideoRef.nativeElement.srcObject = event.streams[0];
      }
    };
  }

  async startScreenShare(localStream: MediaStream) {
    this.setupPeerConnection();
    localStream
      .getTracks()
      .forEach((track) => this.peerConnection!.addTrack(track, localStream));

    const offer = await this.peerConnection!.createOffer();
    await this.peerConnection!.setLocalDescription(offer);

    this.webSocketService.send({
      ACTION: 'SCREEN_SHARE_OFFER',
      CONTENT: {
        offer,
        target: this.remoteUserSub,
        sender: this.localUserSub,
      },
    });
  }

  // handles offe
  async handleOffer(message: BaseMessage) {
    const remoteOffer = message.CONTENT['offer'];

    if (!this.peerConnection) {
      this.setupPeerConnection();
    }
    const pc = this.peerConnection;
    if (pc?.signalingState === 'stable') {
      try {
        await pc!.setRemoteDescription(remoteOffer);

        const answer = await pc!.createAnswer();
        await pc!.setLocalDescription(answer);

        this.webSocketService.send({
          ACTION: 'SCREEN_SHARE_ANSWER',
          CONTENT: {
            answer,
            target: message.CONTENT['sender'],
            sender: this.localUserSub,
          },
        });
      } catch (error) {
        console.error('Failed to handle screen share offer:', error);
      }
    } else {
      console.warn('Offer ignored: PeerConnection not in correct state.');
    }
  }

  async handleAnswer(message: BaseMessage) {
    if (!this.peerConnection) {
      console.warn('Tried to set remote answer with no peer connection.');
      return;
    }
    await this.peerConnection.setRemoteDescription(message.CONTENT['answer']);
  }

  async handleCandidate(message: any) {
    console.log('[ICE message.CONTENT] ', message.CONTENT)
    let candidateInit = message;

    if (!message) {
      console.warn('Candidate is missing or malformed:', message);
      return;
    }

    if (!this.peerConnection) {
      console.warn('Creating new peer connection to handle ICE');
      this.setupPeerConnection();
    }

    try {
      await this.peerConnection!.addIceCandidate(candidateInit);
    } catch (err) {
      console.error('Error adding received ICE candidate', err);
    }
  }
  stopScreenShare() {
    this.peerConnection?.getSenders().forEach((sender) => sender.track?.stop());
    this.peerConnection?.close();
    this.peerConnection = null;

    if (this.remoteVideoRef?.nativeElement.srcObject) {
      (this.remoteVideoRef.nativeElement.srcObject as MediaStream)
        .getTracks()
        .forEach((track) => track.stop());
      this.remoteVideoRef.nativeElement.srcObject = null;
    }
  }
  setupOnTrackHandler(remoteVideoRef:any): void {
     console.log('[DEBUG] Setting up video data')
    if(this.peerConnection && remoteVideoRef){
      console.log('[DEBUG] condition passed')
        this.peerConnection.ontrack = (event) => {
          console.log('[DEBUG] ontrack')
    const [remoteStream] = event.streams;

    if (!remoteStream) {
      console.warn('No remote stream found in ontrack event');
      return;
    }

    remoteVideoRef.srcObject = remoteStream;
    console.log('[DEBUG] video data srcObject', remoteStream)
    remoteVideoRef.onloadedmetadata = async () => {
       console.log('[DEBUG] video data received')
      try {
        await remoteVideoRef.play();
        /* if (remoteVideoRef.requestPictureInPicture) {
          await remoteVideoRef.requestPictureInPicture();
        } */
      } catch (err) {
        console.error('Error enabling Picture-in-Picture', err);
      }
    };
  };
    } else {
        console.log('[DEBUG] peerConnection', this.peerConnection )
        console.log('[DEBUG] remoteVideoRef', this.remoteVideoRef )
        
    }
  
}
}
